export const sendVerificationEmail = async(email, firstName, lastName) => {
	const response = await fetch('/api/send-verification-email', { // Replace '/api/queue' with your actual API endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({"email": email, "first_name": firstName,"last_name":lastName}),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data?.message);
    }
    console.log(data)
}

export const verificationEmail = async (email, code) => {
  try {
    const response = await fetch('/api/verify-code', { // Replace with your actual API endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Failed to verify email. Please try again. If this problem continues, please contact support at 412-231-9310');
      }
      if (response.status === 400) {
        throw new Error(data?.error || 'An error occurred. Please check the verification code and try again.');
      }
      throw new Error(data?.message || 'An unexpected error occurred.');
    }
  } catch (error) {
    console.error('Verification failed:', error.message);
    throw error; // Rethrow the error for the caller to handle
  }
};